import styled, { css } from 'styled-components';

// Desktop: the menu has its own narrow last column, centred on the row.
// Tablet / phone: the cell sits in the card's last column (rowMenuCells)
// under an empty label, so the "⋯" takes the label line (16px) plus a 32px
// value line: centred with a status badge beside it, flush right.
export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${({ theme }) =>
    !theme.responsive.isDesktop &&
    css`
      height: 48px;
      padding-top: 16px;
      box-sizing: border-box;
    `}
`;
